import { NgTemplateOutlet } from '@angular/common'
import { Component, input, TemplateRef } from '@angular/core'
import { ColorName } from '../design-system'
import { Icon, IconComponent, IconSizePx } from '../icon'
import { Illustration, IllustrationComponent } from '../illustration'

@Component({
  selector: 'ftr-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.css'],
  imports: [IllustrationComponent, IconComponent, NgTemplateOutlet],
})
/**
 * A component to display when a section is empty
 */
export class EmptyStateComponent {
  message = input<string>()
  illustration = input<Illustration>()
  icon = input<Icon>()
  inline = input<boolean>(false)
  transparent = input<boolean>(false)
  iconSize = input<IconSizePx>(24)
  iconColor = input<ColorName>('Grey40')

  displayTitle = input<string>()
  messageTemplate = input<TemplateRef<unknown> | null>(null)
}
